import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UpdateAssignedUserModalUI from './UpdateAssignedUserModalUI.js'

class UpdateAssignedUserModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      assignedUserId: this.props.account.assignedUserId,
      assignedUserIdList: [],
      assignedUserIdError: null
    }
  }

  render() {
    return (
      <UpdateAssignedUserModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        assignedUserId={this.state.assignedUserId}
        onAssignedUserIdChange={(event) => { this.setState({ assignedUserId: event.target.value }) }}
        assignedUserIdList={this.state.assignedUserIdList}
        assignedUserIdError={this.state.assignedUserIdError}
        setAssignedUserIdError={(error) => { this.setState({ nameError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.getSuperUsers(context)
  }

  getSuperUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.SuperUsers(),
      callback: this.getSuperUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSuperUsersCallback = (response) => {
    console.log(response.userList)
    let assignedUserIdList = response.userList.map((user, index) => {
      return { key: user.userId, value: user.addressableName};
    });
    this.setState({ errorList: response.errorList, assignedUserIdList: assignedUserIdList })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/assignedUsers`,
      this.onSubmitCallback,
      {
        assignedUserId: this.state.assignedUserId
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 20)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default UpdateAssignedUserModalSF
